import { render, staticRenderFns } from "./CompanyCreateScreen.vue?vue&type=template&id=8407df0a&scoped=true&lang=pug"
import script from "./CompanyCreateScreen.vue?vue&type=script&lang=ts"
export * from "./CompanyCreateScreen.vue?vue&type=script&lang=ts"
import style0 from "./CompanyCreateScreen.vue?vue&type=style&index=0&id=8407df0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8407df0a",
  null
  
)

export default component.exports